import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Section.css';

class Button extends React.Component {
  render() {
    let classes = cx(s.Section);
    if (this.props.main){
      classes = cx(classes, s.Section__main)
    }
    if (this.props.sidebar){
      classes = cx(classes, s.Section__sidebar)
    }
    if (this.props.container){
      classes = cx(classes, s.Section__container)
    }
    return this[this.props.container ? 'renderContainer' : 'renderSection'](classes);  
  };

  renderContainer(classes) {
    return (
      <div className={cx(this.props.className, classes)}>
        {this.props.children}
      </div>
    );
  };

  renderSection(classes) {
    return (
      <section className={cx(this.props.className, classes)}>
        {this.props.children}
      </section>
    );
  };
}

Button.propTypes = {
  main: PropTypes.bool,
  sidebar: PropTypes.bool,
  children: PropTypes.node,
};

export default withStyles(s)(Button);



// WEBPACK FOOTER //
// ./src/components/Section/Section.js